// extracted by mini-css-extract-plugin
export default {"heading":"webpack-pages-StudyList-StudyListExtractionMessage-StudyListExtractionMessage-module__heading"};